import {
  GET_HOTSPOT_CLICK,
  SET_HOTSPOT_CLICK,
} from "../constants/hotspot-click-constants";

export const getHotspotClick = () => ({
  type: GET_HOTSPOT_CLICK,
});

export const setHotspotClick = (status) => ({
  type: SET_HOTSPOT_CLICK,
  status,
});
